import { createSlice } from "@reduxjs/toolkit";
import { EstadoModel } from "../../../models/localizacao/estadoModel";
import { listarEstado } from "../../../services/localizacaoService";
import { resetAll } from "../../actions/actions";

export interface LocalizacaoState {
  //buscar estado
  loadingEstado: boolean;
  listEstado: EstadoModel[];
  entityEstado: EstadoModel;
}

const initialState: LocalizacaoState = {
  //buscar estado
  loadingEstado: false,
  listEstado: [],
  entityEstado: {} as EstadoModel,
};

export const localizacaoSlice = createSlice({
  name: "localizacao",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar estado
    builder.addCase(listarEstado.pending, (state) => {
      state.loadingEstado = true;
    });
    builder.addCase(listarEstado.fulfilled, (state, action) => {
      state.listEstado = action.payload;
      state.loadingEstado = false;
    });
    builder.addCase(listarEstado.rejected, (state, action) => {
      state.loadingEstado = false;
    });
  },
});

export const {} = localizacaoSlice.actions;

export default localizacaoSlice.reducer;
